module.exports = __webpack_public_path__ + "static/guanghuan-97273131ec75a8a54615262ee92cfd90.png";